import { iconArrowTop } from "assets/icons";
import { InputFormField } from "components/InputFormField";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import React, { ChangeEvent, useRef, useState } from "react";
import { ErrorSpan, HiddenSelect, Option, Select, SelectHeader, SelectOptionsContainer, SelectOptionsList } from "./styles";
import { inspect } from "util";

type SizeBtnProps = "small" | "large";
type AppearWhereProps = "bottom" | "top";

export interface SelectProps {
  name: string,
  label: string,
  options: OptionProps[],
  readOnly?: boolean,
  appearWhere?: AppearWhereProps,
  size?: SizeBtnProps,
  block?: boolean,
  value?: string,
  error?: boolean,
  errorMessage?: string,
  search?: boolean,
  searching?: boolean,
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void,
  onSearchInputChange?: (e: ChangeEvent<HTMLInputElement>) => void,
}

interface OptionProps {
  value: string,
  label: string,
}

export const SelectModified: React.FC<SelectProps> = ({
  name,
  label,
  options,
  readOnly = false,
  appearWhere = "bottom",
  size = "large",
  block = false,
  value,
  error,
  errorMessage,
  search,
  searching,
  onChange,
  onSearchInputChange,
}) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [touched, setTouched] = useState<boolean>(!!value);
  const hiddenSelect = useRef<any>(null);
  const selectRef = useRef<any>(null);
  useOnClickOutside(selectRef, () => setShowDropdown(false));

  const onSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    !!onChange && onChange(event);
  }

  const handleOptionSelected = (event: any) => {
    const targetValue = event.target.dataset.value
    const e = new Event("change", { bubbles: true })
    hiddenSelect.current.value = targetValue;
    hiddenSelect.current.dispatchEvent(e);
    setTouched(true);
    setShowDropdown(false);
  }

  const handleShowDropdown = () => {
    if (readOnly) return;
    setShowDropdown(!showDropdown);
  }

  return (
    <Select
      className={'select-modified'}
      block={block}
      ref={selectRef}
    >
      <HiddenSelect
        onChange={onSelectChange}
        name={name}
        value={value}
        ref={hiddenSelect}
      >
        <option disabled/>
        {options.map((option, index) => (
          <option key={option.label+index} value={option.value}>
            {option.label}
          </option>
        ))}
      </HiddenSelect>
      <SelectHeader
        block={block}
        size={size}
        readOnly={readOnly}
        appearWhere={appearWhere}
        showDropdown={showDropdown}
        touched={touched}
        onClick={handleShowDropdown}
        selected={value !== "0" && value !== "undefined" && value !== label && !!value}
        error={error}
      >
        <div className="select">
          <strong>
            {
              options?.find((option) => option.value == value)?.label ?? label
            }
          </strong>
        </div>
        <button type="button">{iconArrowTop}</button>
      </SelectHeader>

      <SelectOptionsContainer
        selected={showDropdown}
        itemSelected={false}
        appearWhere={appearWhere}
      >
        <SelectOptionsList>
          {
            search &&
            <div style={{padding: '8px'}}>
              <InputFormField
                name={`${name}Search`}
                label={'Busca'} 
                marginBotton="0"
                icon={true}
                animation={searching}
                onChange={(e) => onSearchInputChange?.(e)}
              />
            </div>
          }
          {options.map((option) => (
            <Option
              key={option.value}
              data-value={option.value}
              data-label={option.label}
              data-select-name={name}
              onClick={(e) => handleOptionSelected(e)}
              className={value == option.value ? "isActive" : ""}          
            >
              <span></span>
              <strong>{option.label}</strong>
            </Option>
          ))}
        </SelectOptionsList>
      </SelectOptionsContainer>
      {error ? <ErrorSpan>{errorMessage}</ErrorSpan> : null}
    </Select>
  )
}